export const ROUTES = {
  home: "/home",
};
